<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space"><span class="text">{{ msgAlerta }}</span></div>


    <div v-show="!showDocView">
        <div class="form-edit-page row-space">
            <div class="row row-space">
                <div class="form-item-rangedata"><RangeDataSelect :periodoInicial="'currentMonth'" v-model="dateRange" /></div>

                <div class="form-item">
                    <div v-if="globalStore.idestabelecimento">
                        <label class="label-caption">Estabelecimento</label>
                        <div class="field-label">{{ globalStore.nmestabelecimento }}</div>
                    </div>
                    <div v-else>
                        <EstabelecimentoSelect :ckAddTodos="true" v-model:idSelecionado="estabelecimentoSelecionado" />
                    </div>
                </div>

                <button type="button" class="buttom-icon--search" @click="lerDados" />
                <button type="button" class="buttom-icon--close" @click="closeForm" />
            </div>
        </div>

        <div v-if="lsDados.length>0" class="table-wrapper">
            <table>
                <thead><tr>
                    <th>Data</th>
                    <th>Protocolo</th>
                    <th>Formulário</th>
                    <th>S.I.M.</th>
                    <th>Estabelecimento</th>
                    <th>Nro</th>
                    <th>Situação</th>
                </tr></thead>

                <tbody>
                    <tr v-for="(obj, index) in lsDados" :key="obj.idregistro" @click="onClickItem(obj)"
                    :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}">
                        <td class="col-width-char10 center">{{ Funcoes.formatDateFromJson(obj.dtdoc) }}</td>
                        <td class="col-width-char15 center">{{ obj.protocolo }}</td>
                        <td>{{ obj.nmepdocmodelo }}</td>
                        <td class="col-width-char20">{{ obj.nmsim }}</td>
                        <td>{{ obj.nmestabelecimento }}</td>
                        <td class="col-width-char05">{{ obj.nrosim }}</td>
                        <td class="col-width-char20">{{ obj.nmstatus }}</td>
                    </tr>
                </tbody>
            </table>



            <div v-if="showPagination" class="pagination">
                <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
                <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
                <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>
                <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
                <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
            </div>
        </div>
    </div>
    

    <template v-if="showDocView">
        <DocViewPage :idView="idDocSelecionado" @close="showDocView = false" @save="lerDados" />
    </template>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/funcoes';
import { globalStore } from '@/globals';
import DocViewPage from '@/views/docs/visualizacoes/DocViewPage.vue';
import EstabelecimentoSelect from '@/components/selects/EstabelecimentoSelect.vue';
import RangeDataSelect from '@/components/selects/RangeDataSelect.vue';

const idDocSelecionado = ref(0);
const showDocView = ref(false);

const estabelecimentoSelecionado = ref(null);

const dateRange = ref({ startDate: "", endDate: "", selectedPeriod: "" });
const emit = defineEmits(['close']);
const isLoading = ref(false);
const lsDados = ref([]);
const msgAlerta = ref(null);

const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);
const lsDadosMain = ref([]);
const showPagination = ref(false);

const closeForm = () => {emit('close');}


async function lerDados() {
    try{
        Funcoes.validarIntervaloDatas(dateRange.value.startDate, dateRange.value.endDate);
        msgAlerta.value = null;
        isLoading.value = true;
        const dados = {
            idep: globalStore.idep,
            idsim: globalStore.idsim,
            idestabelecimento: ((globalStore.ckperfilestabelecimento) || (globalStore.ckperfilrt)) ? globalStore.idestabelecimento : estabelecimentoSelecionado.value,
            datainicial: dateRange.value.startDate,
            datafinal: dateRange.value.endDate};
        const req = await Api.genericPost('/lsdoc/doc', dados);
        lsDadosMain.value = req;
        currentPage.value=1;
        showPagination.value = (lsDadosMain.value.length > itemsPerPage.value);
        updatePaginatedData();
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}


function onClickItem(obj){
    idDocSelecionado.value = obj.id;
    showDocView.value = true;
}


const updatePaginatedData = () => {
    const startIndex = (currentPage.value - 1) * itemsPerPage.value;
    const endIndex = (startIndex + itemsPerPage.value);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}

onMounted(lerDados)
</script>